export default __webpack_public_path__ + "static/media/dinerototal.52b1fa0a.png";